import {
  equalTo,
  limitToLast,
  orderByChild,
  query as _query,
  endAt,
  startAt,
  Query,
} from 'firebase/database'
import { isEmpty, isObjectLike } from 'lodash-es'

import { isNilOrEmptyString } from '../../helper'

export type Filter = {
  orderBy?: string
  limit?: number
  equalTo?: Record<string, string>
  startAt?: number | string | boolean | null
  endAt?: number | string | boolean | null
}

const hasFilter = (
  filter: Filter[keyof Filter],
): filter is NonNullable<Filter[keyof Filter]> => {
  return !(
    isNilOrEmptyString(filter) ||
    (isObjectLike(filter) && isEmpty(filter))
  )
}

export const applyQueryFilter = (query: Query, filters: Filter) => {
  if (hasFilter(filters.orderBy)) {
    query = _query(query, orderByChild(filters.orderBy))
  }

  if (hasFilter(filters.startAt)) {
    query = _query(query, startAt(filters.startAt))
  }

  if (hasFilter(filters.endAt)) {
    query = _query(query, endAt(filters.endAt))
  }

  if (hasFilter(filters.limit)) {
    query = _query(query, limitToLast(filters.limit))
  }

  if (hasFilter(filters.equalTo)) {
    query = _query(
      query,
      ...Object.entries(filters.equalTo).map(([key, value]) =>
        equalTo(key, value),
      ),
    )
  }

  return query
}
